export const environment = {
  production: false,
  apiUrl:'https://paytek-africa.net:11901/api/apps',
  apiKey:'31|YEwf8ocRy4zyiFGdPKJTXxkkRfKRXbrcjnyfe8Q1',
  appId:'3576128409',
  apiPublicKey:`-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEA0tnN71ibgTryKECTMvt7
M+eqaJwib5ln/Xpk0FA6arbeXlFA2Qr+Wnxf1u5bFABRFZCr4y7df/Bq4tLgY81U
UgjKN9M6Ygi5wnNUqzly+DDz6avidkm8OErhVGl1ir+nVgy4Ivx09u9um+nf/ua1
kZ8KJM2u57nKsCdXhilPoif18X6s+jo33L66aVuAczo+785scOhYvcYWPtH0815a
z6MnbBqBlZ0CGlA4YudiRa3Hm+gYROk/UU7Ol0kWh0hLFwht9LHsDIMI6N3rdCRs
T8rNz3NOdZ5RoXUx8uGwBwH2DHx1IV0AhMGVUjJNCzdYF9MhzCm45FLcSh+VSZ0i
ZoHQIvabkZI77qhe7FfVPqKl9JUt60t0VngCzgx/ql3hg3stNWhQcP/pFeZA7nig
oILojBw1Jr0DlrPmQJ1ff/GlwfbJgY16rlhqdtwPzboRfrDk3QNANygOq8rlTdfy
ku1Y7Xwrk4XOo9ybEjh4HLSuWdd8LdEaOTgn8nInwz2X2dBRlFWmNZ9vyqx26KQC
8akW7O/1M1iocDKAzmphAFQqYoDkUj3GmcoZObBrg4h8KsWjcJjez8I1jw1znppc
IxhAgP/ncQcgZm3QMWPJS2YQEPOqmSEAfx2JyyUT3CSzZP03p1jxV2vNqo0PLGy5
6c/RwJbODviY6LabqtFCBB8CAwEAAQ==
-----END PUBLIC KEY-----`,

  pusherKey: "ad52cb097fca7bdd5e08",
  pusherCluster: "ap2",
  pusherChannel: 'payments',

};
